import { useEffect, useState } from "react";

import { message } from "antd";

import { ISharedStorageLink } from "store/storage/storage.types";
import api from "services/api.service";

export const useSharedStorageLinks = () => {
  const [ links, setLinks ] = useState<ISharedStorageLink[]>([]);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ error, setError ] = useState(false);

  const getSharedStorageLinks = async () => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await api.getSharedStorageLinks();

      if (response.data) {
        setLinks(response.data);
      } else {
        setError(true);
        message.error("Failed to load shared storage links");
      }
    } catch (err) {
      setError(true);
      message.error("Something went wrong while loading shared storage links!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSharedStorageLinks();
  }, []);

  return {
    links,
    isLoading,
    error,
    refetch: getSharedStorageLinks,
  };
};

